module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/location_type_both_location@2x-080d7c5f79e6396d034b9719d4f91a70.webp";